/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
export namespace Types {
  export type CountryCode = 'ca' | 'us';
}

export const CANADA: Types.CountryCode = 'ca';
export const USA: Types.CountryCode = 'us';

export const countries: Types.CountryCode[] = [CANADA, USA];
